<template>
  <b-container fluid>
    <app-sleep
      v-if="showAppSleep"
      @checkSecret="checkSecret($event)"
    ></app-sleep>
    <b-spinner
      class="sync-en-cours"
      variant="success"
      label="Spinning"
      v-if="getLocalDBStatus == 'change' && !storeWillUpdate"
    ></b-spinner>
    <b-spinner
      class="sync-en-cours"
      variant="danger"
      label="Spinning"
      v-if="storeWillUpdate"
    ></b-spinner>
    <img
      :src="require(`@/assets/mobi-offline.png`)"
      class="logo-offline sync-en-cours"
      v-if="getIsOffline"
    />
    <b-row class="layout-main showbox4" :class="{ hasFooter: hasFooter }">
      <div class="header" v-if="hasHeader">
        <app-header-mobile
          @filtres="$emit('filtres', $event)"
          @close-filtre="$emit('close-filtre', $event)"
          @selected-palette="$emit('selected-palette', $event)"
          @undo-lastaction="$emit('undo-lastaction')"
          @conf-reserv="$emit('conf-reserv')"
          @date-time="$emit('date-time', $event)"
          @filtre-autori="$emit('filtre-autori', $event)"
          @refresh-filter="$emit('refresh-filter')"
          @individus-jour="$emit('individus-jour', $event)"
          :hasFilter="hasFilter"
          :hasSubHeader="hasSubHeader"
          :filtreScolarite="filtreScolarite"
          :filtrePointage="filtrePointage"
          :listRegim="listRegim"
          :vieQuoRegimeAli="vieQuoRegimeAli"
          :countRegim="countRegim"
          :listVille="listVille"
          :lastAction="lastAction"
          :currentEtabLogo="currentEtabLogo"
          :currentEtabName="currentEtabName"
          :hasDynamicDate="hasDynamicDate"
          :currentActivite="currentActivite"
          :dateTimeChanged="currentDate"
          :getMemDBStatus="getMemDBStatus"
          :updateOnlineStatus="updateOnlineStatus()"
          :isIndividuDuJours="isIndividuDuJours"
          :selectedPageSize="selectedPageSize"
          :currentPage="currentPage"
          :maxPage="maxPage"
          @next-page="$emit('next-page')"
          @previous-page="$emit('previous-page')"
          @change-page-size="$emit('change-page-size', $event)"
          :paletteEnCours="paletteEnCours"
        />
      </div>
      <b-col :class="'layout-left ' + layoutLeftClass" v-if="hasLeftLayout">
        <slot name="layout-left"></slot>
      </b-col>
      <b-col class="showbox">
        <b-row class="layout-title showbox3">
          <slot name="layout-title"></slot>
        </b-row>
        <b-row class="layout-body h-100" v-if="hasBodyLayout">
          <b-col>
            <slot name="layout-body"></slot>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="hasFooter" class="layout-fotter">
      <b-col>
        <app-footer
          :hasTimer="hasTimer"
          :centerMd="centerMd"
          class="font-italic"
        />
      </b-col>
    </b-row>
    <app-dev-tool v-if="DEVTOOL" />
  </b-container>
</template>

<script>
import AppHeaderMobile from "@/components/app-header-mobile.vue";
import AppFooter from "@/components/app-footer.vue";
import AppSleep from "@/components/app-sleep.vue";
import AppDevTool from "./app-dev-tool";
import { mapGetters } from "vuex";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
import { FiltrePointage } from "@/models/_FiltresPointage";
import { PaletteDocument } from '@/models/PaletteDocument';

export default {
  props: {
    hasDynamicDate: {
      type: Boolean,
      default: false,
    },
    hasBodyLayout: {
      type: Boolean,
      default: true,
    },
    hasHeader: {
      type: Boolean,
      default: true,
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
    hasTimer: {
      type: Boolean,
      default: false,
    },
    hasPreviousBtn: {
      type: Boolean,
      default: false,
    },
    hasLeftLayout: {
      type: Boolean,
      default: false,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    hasSubHeader: {
      type: Boolean,
      default: false,
    },
    filtreScolarite: {
      type: FiltreScolarite,
      default: () => new FiltreScolarite(),
    },
    filtrePointage: {
      type: FiltrePointage,
      default: () => new FiltrePointage(),
    },
    listRegim: {
      //FiltreIndividus
      type: Array,
      default: () => [],
    },
    vieQuoRegimeAli: {
      //FiltreIndividus
      type: Array,
      default: () => [],
    },
    countRegim: {
      //FiltreIndividus
      type: Array,
      default: () => [],
    },
    listVille: {
      //FiltreIndividus
      type: Array,
      default: () => [],
    },
    importationState: {
      type: Array,
      default: () => [],
    },
    lastAction: {
      type: Object,
      default: () => {},
    },
    currentEtabLogo: {
      type: String,
      default: " ",
    },
    currentEtabName: {
      type: String,
      default: " ",
    },
    currentActivite: {
      type: Object,
      default: () => {},
    },
    currentDate: {
      type: String,
      default: "",
    },
    getMemDBStatus: {
      type: String,
      default: "",
    },
    centerMd: {
      type: Number,
      default: 7,
    },
    storeWillUpdate: {
      type: Boolean,
    },
    isIndividuDuJours: {
      type: Boolean,
      default: true,
    },
    redirectIfSleep: {
      type: Boolean,
      default: false,
    },
    selectedPageSize: {
      type: Number,
      default: 9999,
    },
    paletteEnCours: {
      type: PaletteDocument,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showAppSleep: false,
    };
  },
  components: {
    AppHeaderMobile,
    AppFooter,
    AppDevTool,
    AppSleep,
  },
  created() {
    document.addEventListener("visibilitychange", this.visibilityChange, false);
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });
    document.addEventListener("swDownload", this.showNotificationMaj, {
      once: true,
    });
  },
  methods: {
    notifyWithServiceWorker(title, options) {
      const swreg = this.$swreg;
      if (swreg && typeof swreg.showNotification === "function") {
        return swreg.showNotification(title, options);
      }
      console.warn("[ANMOBI][APP-LAYOUT] SW registration indisponible, notification ignorée", {
        title,
      });
      return Promise.resolve();
    },
    visibilityChange(e) {
      this.showAppSleep = !this.DEVTOOL && this.redirectIfSleep;
    },
    updateOnlineStatus(event) {
      return navigator.onLine;
    },
    checkSecret(event) {
      this.showAppSleep = !event;
    },
    showNotificationMaj() {
      this.notifyWithServiceWorker("Mise à jour Mobi disponible", {
        body: "Votre application Mobi va maintenant se mettre à jour automatiquement",
        tag: "InoeMobi",
        icon: "./img/icons/android-icon-96x96.png",
      });
    },
  },
  watch: {
    getIsOffline(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.notifyWithServiceWorker("Mode Hors connexion activé", {
          body: "Mobi fonctionnne maintenant sans connexion internet.",
          tag: "InoeMobi",
          icon: "./img/icons/android-icon-96x96.png",
        });
      }
    },
  },
  computed: {
    DEVTOOL: {
      get: function () {
        return process.env.VUE_APP_DEVTOOL === "true";
      },
    },
    ...mapGetters("session", ["getLocalDBStatus", "getIsOffline"]),
  },
};
</script>

<style scoped lang="scss">
.progress-div {
  position: fixed;
  top: 1%;
  left: 1%;
  width: 30%;
  height: auto;
  background-color: #c9bad2;
  z-index: 99;
  border-radius: 15px;
  padding: 10px;
  span {
    font-size: calc(7px + 0.5vw);
    color: rgba(37, 150, 136, 1);
  }
  .prog-bar {
    background-color: white;
    margin: 10px auto;
  }
}
.layout-main {
  background: rgb(37, 150, 136);
  background: linear-gradient(
    90deg,
    rgba(37, 150, 136, 1) 0%,
    rgba(52, 187, 210, 1) 50%,
    rgba(37, 150, 136, 1) 100%
  );
  min-height: 100vh;
}
.hasFooter {
  min-height: calc(100vh - 120px) !important;
}
.header {
  width: 100%;
}
.modalConf {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: #c9bad2;
  z-index: 15;
  padding: 2vw;
  border-radius: 20px;
  width: 50vw !important;
  height: 60vh;
  margin-top: -30vh; /*set to a negative number 1/2 of your height*/
  margin-left: -25vw; /*set to a negative number 1/2 of your width*/
  border: #663c82 solid 3px;
  span {
    font-size: calc(12px + 1vw);
    color: white;
    b {
      color: #00798a;
    }
  }
}

.sync-en-cours {
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;
  z-index: 99;
}
// Extra small devices (portrait phones, less than 576px)
@include media-breakpoint-up(sm) {
}
// Small devices (landscape phones, less than 768px)
@include media-breakpoint-up(md) {
}
// Medium devices (tablets, less than 992px)
@include media-breakpoint-up(lg) {
}
// Large devices (desktops, less than 1200px)
@include media-breakpoint-up(xl) {
}
</style>
